module.exports = "/app/themes/roboyo2021/dist/img/arrow-right.svg?7b835ff0e843de9108dc1b7210a8b17a";